import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import LoadingScreen from '../shared/loading/LoadingScreen';

const AuthenticatedRoute = () => {
  const { authenticated } = useContext(UserContext);

  if (authenticated === null) return <LoadingScreen />;

  return authenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default AuthenticatedRoute;
